export const AuthEndpoint = {
    LOGIN: "authentication/login",
    USER_DETAILS: "ess/teams/self",
    SIGN_UP: "authentication/signup",
    FORGOT_PASSWORD: "authentication/forgotpassword",
    VERIFY_PASSWORD: "authentication/verifypassword",
    SETUP_2FA: "authentication/setup-2fa",
    CONFIRM_2FA: "authentication/confirm-2fa",
    DISABLE_2FA: "authentication/disable-2fa",
    VERIFY_LOGIN_2FA: "authentication/verify-login-2fa",
    RECOVER_2FA: "authentication/recover-2fa",
    VERIFY_RECOVER_2FA: "authentication/verify-recover-2fa",
}

//#region----------------DASHBOARD--------------------//
const DASHBOARD_BASE_URL = "dashboard";

export const DashboardEndpoint = {
    DASHBOARD_URL: DASHBOARD_BASE_URL,
    DASHBOARD_NOTICES_URL: `${DASHBOARD_BASE_URL}/notices`,
}
//#endregion

//#region----------------NEWS--------------------//
const NEWS_BASE_URL = "news";

export const NewsEndpoint = {
    NEWS_URL: NEWS_BASE_URL,
    NEWS_BY_ID_URL: (id: string | number) => `${NEWS_BASE_URL}/${id}`,
    NEWS_COVER_PHOTO_BY_ID_URL: (id: string | number) => `${NEWS_BASE_URL}/${id}/cover/download`,
    NEWS_DELETE_BY_ID_URL: (id: string | number) => `${NEWS_BASE_URL}/${id}/delete`,
}
//#endregion

//#region----------------LICENSES--------------------//
const LICENSE_BASE_URL = "licenses";

export const LicensesEndpoint = {
    LICENSES_URL: LICENSE_BASE_URL,
    LICENSE_BY_ID_URL: (id: string | number) => `${LICENSE_BASE_URL}/${id}`,
    LICENSE_DELETE_BY_ID_URL: (id: string | number) => `${LICENSE_BASE_URL}/${id}/delete`,
    LICENSE_GENERATE_URL: `${LICENSE_BASE_URL}/generate`,
    LICENSE_PACKAGE_BUY_URL: `${LICENSE_BASE_URL}/buylicensepackage`,
    LICENSE_BUY_URL: `${LICENSE_BASE_URL}/buylicense`,
    LICENSE_ALLOCATE_URL: (id: string | number) => `${LICENSE_BASE_URL}/${id}/allocate`,
    LICENSE_ASSIGN_URL: (id: string | number) => `${LICENSE_BASE_URL}/${id}/assign`,
    LICENSE_INVALIDATE_URL: (id: string | number) => `${LICENSE_BASE_URL}/${id}/invalidate`,
    LICENSE_GENERATE_INVOICE_URL: (id: string | number) => `${LICENSE_BASE_URL}/${id}/generate/invoice`,
}
//#endregion

//#region----------------COMPANIES--------------------//
const COMPANY_BASE_URL = "companies";

export const CompaniesEndpoint = {
    COMPANIES_URL: COMPANY_BASE_URL,
    COMPANIES_PUBLIC_URL: `${COMPANY_BASE_URL}/public`,
    COMPANY_BY_ID_URL: (id: string | number) => `${COMPANY_BASE_URL}/${id}`,
    COMPANY_DELETE_BY_ID_URL: (id: string | number) => `${COMPANY_BASE_URL}/${id}/delete`,
    COMPANY_LICENSE_HISTORY_BY_COMPANY_ID_URL: (id: string | number) => `${COMPANY_BASE_URL}/${id}/licensehistory`,
    COMPANY_USERS_URL: (companyId: string | number) => `${COMPANY_BASE_URL}/${companyId}/users`,
    COMPANY_USER_BY_ID_URL: (companyId: string | number, userId: string | number) => `${COMPANY_BASE_URL}/${companyId}/users/${userId}`,
    COMPANY_BY_REGISTRATION_CODE_URL: (registrationCode: string | number) => `${COMPANY_BASE_URL}/registration-code/${registrationCode}`,
    COMPANY_BY_VENDOR_REGISTRATION_CODE_URL: (vendorRegistrationCode: string | number) => `${COMPANY_BASE_URL}/vendor-registration-code/${vendorRegistrationCode}`,
    COMPANY_GENERATE_DATABASE_BY_ID_URL: (id: string | number) => `${COMPANY_BASE_URL}/${id}/generateDatabase`,
    COMPANY_SYNC_USERS: (id: string | number) => `${COMPANY_BASE_URL}/${id}/syncusers`,
}
//#endregion

//#region----------------ADMIN USERS--------------------//
const USER_BASE_URL = "users";

export const UsersEndpoint = {
    USERS_URL: USER_BASE_URL,
    USER_DELETE_BY_ID_URL: (id: string | number) => `${USER_BASE_URL}/${id}/delete`,
    USER_RESET_PASSWORD_BY_ID_URL: (id: string | number) => `${USER_BASE_URL}/${id}/resetpassword`,
    USER_PROFILE_PHOTO_BY_ID_URL: (id: string | number) => `${USER_BASE_URL}/${id}/profile/download`,
    USER_UPLOAD_PROFILE_PHOTO_BY_ID_URL: (id: string | number) => `${USER_BASE_URL}/${id}/profile/upload`,
    USER_BY_ID_URL: (id: string | number) => `${USER_BASE_URL}/${id}`,
    USER_PROFILE_BY_ID_URL: (id: string | number) => `${USER_BASE_URL}/${id}/profile`,
}
//#endregion

//#region----------------BILLINGS--------------------//
const BILLING_BASE_URL = "invoices";

export const BillingsEndpoint = {
    BILLINGS_URL: BILLING_BASE_URL,
    BILLING_BY_ID_URL: (id: string | number) => `${BILLING_BASE_URL}/${id}`,
    BILLING_SETTLE_BY_ID_URL: (id: string | number) => `${BILLING_BASE_URL}/${id}/settle`,
    BILLING_DELETE_BY_ID_URL: (id: string | number) => `${BILLING_BASE_URL}/${id}/delete`,
}
//#endregion

//#region----------------PAYMENTS--------------------//
const PAYMENTS_BASE_URL = "payments";

export const PaymentsEndpoint = {
    STRIPE_WEBHOOK_URL: `${PAYMENTS_BASE_URL}/stripe/webhook`,
    STRIPE_SETUP_INTENT_URL: `${PAYMENTS_BASE_URL}/stripe/setupintent`,
    STRIPE_MAKE_PAYMENT_URL: `${PAYMENTS_BASE_URL}/stripe/makepayment`,
}
//#endregion

//#region----------------MAINTENANCE--------------------//

//#region----------------ROLES--------------------//
const ROLES_BASE_URL = "roles";

export const RolesEndpoint = {
    ROLES_URL: ROLES_BASE_URL,
    ROLES_BY_ID_URL: (id: string | number) => `${ROLES_BASE_URL}/${id}`,
    ROLES_ACCESSIBILITIES_BY_ROLE_ID_URL: (id: string | number) => `${ROLES_BASE_URL}/${id}/accessibilities`,
    ROLES_DELETE_BY_ID_URL: (id: string | number) => `${ROLES_BASE_URL}/${id}/delete`,
}
//#endregion

//#region----------------MODULES SETTINGS--------------------//
const MODULES_SETTINGS_BASE_URL = "modules";

export const ModulesSettingsEndpoint = {
    MODULES_SETTINGS_URL: MODULES_SETTINGS_BASE_URL,
    MODULES_SETTINGS_BY_ID_URL: (id: string | number) => `${MODULES_SETTINGS_BASE_URL}/${id}`,
    MODULES_SETTINGS_DELETE_BY_ID_URL: (id: string | number) => `${MODULES_SETTINGS_BASE_URL}/${id}/delete`,
}
//#endregion

//#region----------------PRICE SETTINGS--------------------//
const PRICE_SETTINGS_BASE_URL = "settings/latest";

export const PriceSettingsEndpoint = {
    PRICE_SETTINGS_URL: `${PRICE_SETTINGS_BASE_URL}/price`,
    PRICES_SETTINGS_URL: `${PRICE_SETTINGS_BASE_URL}/prices`,
    MODULES_PRICE_SETTINGS_URL: `${PRICE_SETTINGS_BASE_URL}/modules`,
    STORAGES_PRICE_SETTINGS_URL: `${PRICE_SETTINGS_BASE_URL}/storages`,
    USER_TIERS_PRICE_SETTINGS_URL: `${PRICE_SETTINGS_BASE_URL}/usertiers`,
}
//#endregion

//#region----------------VENDORS--------------------//
const VENDORS_BASE_URL = "vendors";

export const VendorsEndpoint = {
    VENDORS_URL: VENDORS_BASE_URL,
    VENDORS_BY_ID_URL: (id: string | number) => `${VENDORS_BASE_URL}/${id}`,
    VENDORS_DELETE_BY_ID_URL: (id: string | number) => `${VENDORS_BASE_URL}/${id}/delete`,
}
//#endregion

//#region----------------REGISTRATION CODES--------------------//
const REGISTRATION_CODES_BASE_URL = "registrationcodes";

export const RegistrationCodesEndpoint = {
    REGISTRATION_CODES_URL: REGISTRATION_CODES_BASE_URL,
    REGISTRATION_CODES_BY_ID_URL: (id: string | number) => `${REGISTRATION_CODES_BASE_URL}/${id}`,
    REGISTRATION_CODES_DELETE_BY_ID_URL: (id: string | number) => `${REGISTRATION_CODES_BASE_URL}/${id}/delete`,
}
//#endregion

//#endregion